import { render, staticRenderFns } from "./CheckNew.vue?vue&type=template&id=06531673&scoped=true"
import script from "./CheckNew.vue?vue&type=script&lang=js"
export * from "./CheckNew.vue?vue&type=script&lang=js"
import style0 from "./CheckNew.vue?vue&type=style&index=0&id=06531673&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06531673",
  null
  
)

export default component.exports